export default "__VITE_PUBLIC_ASSET__c8ca2f58__"